module.exports = __webpack_public_path__ + "static/img/icon_dlcg@2x.5ecdceff.png";